import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../../components/common/faq";

const faqs = [
  {
    question:
      "How do I find the right mobile app development company in Toronto?",
    answer: `<p>Start by researching app development companies online and checking their portfolio of past work. Look for companies with experience in your industry and positive customer reviews. Consider factors such as pricing, turnaround time, and customer support before making a decision. You can also search for a mobile app development company near me to contact the top app development company in Toronto, Canada.</p>`,
  },
  {
    question:
      "What is the typical cost of developing a mobile app with a Toronto app development company?",
    answer: `<p>The cost of developing a mobile app varies depending on factors such as the app's complexity, the features and functionality required, and the amount of time it takes to develop. It's best to request a quote from the mobile app development company in Toronto to get an accurate estimate.</p>`,
  },
  {
    question:
      "How long does it take to develop a mobile app with a Toronto app development company?",
    answer: `<p>The time it takes to develop a mobile app depends on various factors, such as the app's complexity, the features and functionality required, and the level of customization needed. The average time that a normal application takes is between 6-8 months. However, a professional mobile app development company should be able to provide you with a timeline for your project.</p>`,
  },
  {
    question:
      "What are the steps involved in mobile application development with a Toronto app development company?",
    answer: ` <p>The steps in mobile app development typically include creativity and planning, design, development, testing, and deployment. Each step is crucial in ensuring the success of the mobile app, and a reputable app development company should have a clear process in place for each step.</p>`,
  },
  {
    question: "How do I ensure the security and privacy of my mobile app?",
    answer: `<p>A reputable mobile app development company in Toronto will always prioritize the security and privacy of your mobile app. Look for companies with experience with secure app development and adhere to industry best practices for data protection. Ask about their data security measures and protocols for handling sensitive information.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
